(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('FrequentlyAskedQuestion', FrequentlyAskedQuestion);

    FrequentlyAskedQuestion.$inject = ['$resource', 'DateUtils'];

    function FrequentlyAskedQuestion ($resource, DateUtils) {
        var resourceUrl =  'api/frequently-asked-questions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationTime = DateUtils.convertDateTimeFromServer(data.creationTime);
                        data.updateTime = DateUtils.convertDateTimeFromServer(data.updateTime);
                        data.revisionTime = DateUtils.convertDateTimeFromServer(data.revisionTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
